import React, { useState } from "react";
import Select from "react-select";
import generate from "../../../Assets/images/generate.gif";

import { createPortal } from "react-dom";
import { Modal } from "react-bootstrap";

const CreateAiModelPop = ({ createAi, setCreateAi }) => {
  const handleCreateAi = () => {
    setCreateAi(!createAi);
  };
  return (
    <>
      <Modal
        show={createAi}
        onHide={handleCreateAi}
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
      >
        <div className="modalBody py-2 px-2 lg:px-5">
          <div className="formBody pt-4">
            <div className="text-center">
              <div className="position-relative px-3">
                {/* <Image
                    src={generate}
                    alt=""
                    height={10000}
                    width={10000}
                  /> */}
                <img
                  src={generate}
                  alt=""
                  style={{ maxWidth: 300 }}
                  className="img-fluid mx-auto w-100 h-auto rounded"
                />
                <div
                  className=" bottom-4 left-0 right-0 w-100 mt-3"
                  // style={{ bottom: 10 }}
                >
                  <h4 className="m-0 text-xl themeClr fw-bold">
                    Creating Your AI
                  </h4>
                </div>
              </div>
              <p className="m-0 text-[#B7B5B4]">
                Your AI will be ready shortly (~30 seconds)
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreateAiModelPop;
const crossIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.11612 1.11612C1.60427 0.62796 2.39573 0.62796 2.88388 1.11612L8 6.2322L13.1161 1.11612C13.6043 0.62796 14.3957 0.62796 14.8839 1.11612C15.372 1.60427 15.372 2.39573 14.8839 2.88388L9.7678 8L14.8839 13.1161C15.372 13.6043 15.372 14.3957 14.8839 14.8839C14.3957 15.372 13.6043 15.372 13.1161 14.8839L8 9.7678L2.88388 14.8839C2.39573 15.372 1.60427 15.372 1.11612 14.8839C0.62796 14.3957 0.62796 13.6043 1.11612 13.1161L6.2322 8L1.11612 2.88388C0.62796 2.39573 0.62796 1.60427 1.11612 1.11612Z"
      fill="white"
    />
  </svg>
);
